module.exports = __webpack_public_path__ + "media/images/thorrel-desc-1-9b17c977eae58eaf4138495a2c249cac.png";